import React, { Fragment, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import { ModalService } from 'common/Services/ModalService'
import GamesService from 'common/Services/GamesService'
import { COLORS } from 'themes'
import device from 'utils/mediaQueries'
import UserService from 'services/UserService'
import Text from 'ui/Text'
import { JackpotWrapper } from 'ui/JackpotWrapper'
import GameLabel from 'ui/GameLabel'
import { EXCLUSIVE_GAME_LABEL } from 'configs/ui'
import CardImage from 'ui/CardImage'
import { useHistory } from 'react-router-dom'
import { detectMobile } from 'common/adapters/DeviceDetectAdapter'
import ReactTooltip from 'react-tooltip'
import Wrapper from 'ui/Wrapper'
import { PROVIDERS } from 'common/providers'
import { LiveCasinoGameCard } from '@bet25/live-casino'
import ServiceButtons from 'features/GamesList/ServiceButtons'

const getCardSize = (props) => {
    let { size = 'x2' } = props
    let styles = null
    if (size === 'x1') {
        styles = css`
            width: 16.66%;
            max-width: 16.66%;
            margin: 0 0 11px 0;
            height: auto;

            @media screen and ${device.lg} {
                max-width: 25%;
                width: 25%;
            }
            @media screen and ${device.md} {
                max-width: 33%;
                width: 33%;
            }
            @media screen and ${device.sm} {
                max-width: 50%;
                width: 50%;
            }
        `
    } else if (size === 'x2') {
        styles = css`
            width: 25%;
            max-width: 25%;
            margin: 0 0 11px 0;
            height: 240px;
            @media screen and ${device.xxl} {
                height: 160px;
            }
            @media screen and ${device.xl} {
                height: 139px;
            }
            @media screen and ${device.lg} {
                max-width: 33%;
                width: 33%;
                height: auto;
            }
            @media screen and ${device.sm} {
                max-width: 50%;
                width: 50%;
                margin: 0 0 15px 0;
            }
        `
    } else if (size === 'x3') {
        styles = css`
            width: 50%;
            max-width: 50%;
            margin: 0 0 11px 0;
            height: 490px;
            @media screen and ${device.xxl} {
                height: 320px;
            }
            @media screen and ${device.xl} {
                height: 285px;
                margin: 0 0 11px 0;
            }
            @media screen and ${device.lg} {
                max-width: 33%;
                width: 33%;
                height: 146px;
            }
            @media screen and ${device.sm} {
                max-width: 50%;
                width: 50%;
                margin: 0 0 15px 0;
                height: auto;
            }
        `
    } else if (size === 'x4') {
        styles = css`
            width: 100%;
            max-width: 100%;
            margin: 0 0 15px 0;
        `
    } else if (size === 'autoHalf') {
        styles = css`
            width: 50%;
            max-width: 50%;
            margin: 0 0 20px 0;
            height: auto;
        `
    }
    return styles
}

const CardWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    float: ${({ float }) => (float ? float : 'none')};
    transition: all 0.3s ease;
    padding: 0 5px;
    box-sizing: border-box;
    ${(props) => getCardSize(props)};
`

const ImageWrapper = styled.div`
    position: relative;
    width: 100%;
    overflow: hidden;
    border-radius: 5px;
`

const LabelWrapper = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
`

const Title = styled.div`
    font-size: 10px;
    line-height: 16px;
    color: ${COLORS.primaryText};
    margin: 4px 0 0 0;
`

const ProviderName = styled.div`
    font-size: 10px;
    line-height: 16px;
    color: ${(props) =>
        props.providerColor
            ? props.providerColor
            : COLORS.colorTextTertiaryDefault};
    text-transform: capitalize;
`

const GameCard = ({
    game = {},
    showTitle = true,
    providerColor = '',
    showLabel = true,
    favorite = false,
    exclusive = false,
    size,
    float,
    gridItem,
}) => {
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(false)
    const [hoverState, setHoverState] = useState(false)

    const history = useHistory()

    const isLiveCasino = game.category === 'liveint'

    useEffect(() => {
        detectMobile() && setHoverState(true)

        const logedInSub = UserService.getUserLoggedStatus().subscribe(
            (res) => {
                setIsUserLoggedIn(res)
            }
        )

        return () => {
            ReactTooltip.hide()
            logedInSub.unsubscribe()
        }
    }, [])

    const findProvider = (providerKey) =>
        PROVIDERS.find((item) => item.value === providerKey)

    const getProviderLabel = (subprovider) => {
        const normalizedKey = subprovider === 'gdm' ? 'scientific' : subprovider
        const provider = findProvider(normalizedKey)
        return provider && provider.label ? provider.label : subprovider
    }

    const gameStart = (mode = 'fun') => {
        ModalService.closeModal()
        GamesService.pushGameToRecentlyPlayed(game.id)
        GamesService.checkLoginBeforeStart(game, history, mode, isUserLoggedIn)
    }

    return (
        <CardWrapper
            size={size}
            float={float}
            gridItem={gridItem}
            onClick={(e) => (!isLiveCasino ? gameStart('money') : null)}
            onMouseOver={() => !detectMobile() && setHoverState(true)}
            onMouseLeave={() => !detectMobile() && setHoverState(false)}
        >
            <ImageWrapper>
                {!isLiveCasino ? (
                    <Fragment>
                        <CardImage key={game.id} game={game} />
                        {showLabel && exclusive ? (
                            <LabelWrapper>
                                <GameLabel {...EXCLUSIVE_GAME_LABEL} />
                            </LabelWrapper>
                        ) : null}
                        {game.jackpot_amount_formatted && (
                            <JackpotWrapper>
                                <Text white>
                                    {game.jackpot_amount_formatted} kr.
                                </Text>
                            </JackpotWrapper>
                        )}
                        {hoverState && (
                            <ServiceButtons
                                isUserLoggedIn={isUserLoggedIn}
                                favorite={favorite}
                                game={game}
                                showFavoriteButton={true}
                                showInfoIcon={true}
                            />
                        )}
                    </Fragment>
                ) : (
                    <Fragment>
                        <LiveCasinoGameCard
                            key={game.id}
                            themeName={'go'}
                            thumbSize={size === 'x3' ? 'XL' : 'M'}
                            game={game}
                            height={'100%'}
                            showTitle={false}
                            withHoverScale={true}
                            gameClickHandler={() => gameStart('money')}
                        />
                        {hoverState && (
                            <ServiceButtons
                                isUserLoggedIn={isUserLoggedIn}
                                favorite={favorite}
                                showInfoIcon={false}
                                game={game}
                            />
                        )}
                    </Fragment>
                )}
            </ImageWrapper>
            {showTitle && (
                <Wrapper height={'40px'} padding={'0px'}>
                    <Title>{game.name}</Title>
                    <ProviderName providerColor={providerColor}>
                        {getProviderLabel(game.subprovider)}
                    </ProviderName>
                </Wrapper>
            )}
        </CardWrapper>
    )
}

export default GameCard
